export enum DiscountCategory {
  Recover = "RECOVER",
  ShopperAi = "SHOPPER_AI",
  ShopperAgent = "SHOPPER_AGENT",
  Marketing = "MARKETING",
  CoverageIncentive = "COVERAGE_INCENTIVE",
}
